import createCachedSelector from '@utils/cached-selector'
import { createSelector } from 'reselect'

export const selectUserById = createCachedSelector(
  (s, id) => s.Users[id],
  (user) => user,
)((_s, id) => id)

export const selectUsers = createSelector(
  (s) => s.Users,
  (users) => users,
)
